<template>
  <svg
    :class="svgClass"
    aria-hidden="true"
    :style="{
      width: size ?? '1em',
      height: size ?? '1em'
    }"
  >
    <use :xlink:href="iconName" :fill="color" />
  </svg>
</template>

<script setup lang="ts">
import { computed } from 'vue'

interface IProp {
  iconClass: string
  className?: string
  color?: string
  size?: string
}
const props = defineProps<IProp>()
const iconName = computed(() => {
  return `#icon-${props.iconClass}`
})
const svgClass = computed(() => {
  if (props.className) {
    return `svg-icon ${props.className}`
  }
  return 'svg-icon'
})
</script>

<style lang="less" scoped>
.sub-el-icon,
.nav-icon {
  display: inline-block;
  font-size: 15px;
  margin-right: 12px;
  position: relative;
}
.svg-icon {
  //width: 1em;
  //height: 1em;
  position: relative;
  fill: currentColor;
  //vertical-align: -2px;
}
</style>
